import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=46faefd2&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports